<template>
  <v-app>
    <loading-view v-if="loading" />
    <!--    <error-view v-else-if="hasErrors" />-->
    <main-layout v-else />
  </v-app>
</template>

<script>
import LoadingView from '@/components/LoadingScreen'
// import ErrorView from '@/views/ErrorView'
import MainLayout from '@/layouts/MainLayout'

export default {
  name: 'App',
  components: { MainLayout, LoadingView },
  data() {
    return {
    }
  },
  computed: {
    hasErrors() {
      return this.$store.getters[this.$storeGetters.APP_HAS_ERRORS]
    },
    loading() {
      return this.$store.getters[this.$storeGetters.AUTH_LOADING]
    }
  }
}
</script>
